import { Box, Chip, Input, Stack } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import styled from 'styled-components';
import { abyssColors } from '@/theme/colors';

export const Field = muiStyled(Box)<{ selected: boolean }>(({ selected }) => ({
  padding: '1.2rem',
  cursor: 'pointer',
  fontSize: '1.4rem',
  background: selected ? abyssColors.primary[100] : abyssColors.primary[50],
  '&:hover': {
    background: selected ? abyssColors.primary[200] : abyssColors.primary[100],
  },
}));

export const FieldPanel = muiStyled(Stack)({
  width: 'calc(100% - 30rem)',
  background: abyssColors.primary[50],
  padding: '1.6rem',
});

export const LineBreak = muiStyled(Box)({
  width: '100%',
  height: '1px',
  background: abyssColors.primary[200],
});

export const FormHeader = muiStyled(Stack)({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const FieldsList = muiStyled(Stack)({
  width: '100%',
  maxWidth: '30rem',
});

export const OptionsContainer = muiStyled(Stack)({
  padding: '16px',
  borderRadius: '8px',
  height: '40rem',
  background: abyssColors.primary[100],
  overflow: 'scroll',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
  gap: '16px',
});

export const OptionBox = muiStyled(Box)({
  padding: '12px',
  borderRadius: '8px',
  background: abyssColors.neutral[50],
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  '& .MuiSvgIcon-root': {
    cursor: 'pointer',
    fontSize: '1.6rem',
  },
});

export const dropDownStyles = {
  maxWidth: '30rem',
  '&.MuiFormControl-root': { marginTop: '0px !important' },
};

export const DropDownContainer = muiStyled(Stack)({
  flexDirection: 'row',
  gap: '8px',
  alignItems: 'center',
  width: '100%',
  maxWidth: '50rem',
  justifyContent: 'space-between',
});

export const VisuallyHiddenInput = muiStyled(Input)({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export const tooltipStyles = {
  '& .MuiTooltip-tooltip': {
    backgroundColor: '#000000B8',
    color: abyssColors.primary[50],
    opacity: 1,
    fontSize: '1rem',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 500,
  },
  '& .MuiTooltip-arrow': {
    color: '#000000B8',
  },
};

export const AdditionalOptions = styled.span`
  line-height: normal;
  font-size: 1rem;
  margin-right: 10px;
  cursor: pointer;
`;

export const OptionChip = muiStyled(Chip)(() => ({
  lineHeight: 'normal',
  fontSize: '1rem',
  background: abyssColors.primary[100],
  color: abyssColors.primary[500],
  height: '24px',
  borderRadius: '16px',
  '& .MuiChip-label': {
    paddingLeft: '10px',
    paddingRight: '10px',
    marginBottom: '-1px',
  },
  '& .MuiChip-deleteIcon': { color: abyssColors.primary[300], fontSize: '1.6rem' },
}));

export const feedbackContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  py: 7,
};
